import React from 'react'

const HeroSection = ({ children }) => {
  return (
    <div className="hero-section font-[Good Times] uppercase text-white py-8 px-6 md:py-14">
      {children}
    </div>
  )
}

export default HeroSection
